<div
  *ngIf="!disabled"
  class="input-group"
  [ngClass]="style === 'filter' ? 'input-group-no-border' : ''"
  (click)="!disabled && onShowItems($event)"
>
  <ion-label class="dropdown-input"> {{ text }} </ion-label>

  <div class="input-icon">
    <ion-icon *ngIf="!showSpinner" name="chevron-down"></ion-icon>
    <ion-spinner *ngIf="showSpinner" name="crescent"></ion-spinner>
  </div>

  <div
    class="dropdown-content"
    [ngClass]="showItems ? 'dropdown-content-show' : ''"
  >
    <div *ngIf="showSearchbar" class="dropdown-search-box">
      <ion-searchbar
        class="dropdown-search"
        animated
        inputmode="text"
        [debounce]="ionSearchDebounceTime"
        [(ngModel)]="searchText"
        (ionInput)="getFilterValue($event)"
        (click)="searchClick($event)"
      ></ion-searchbar>
    </div>

    <div
      *ngFor="let item of filteredList"
      class="dropdown-item"
      (click)="onAction($event, item)"
    >
      <ion-checkbox
        *ngIf="multiple"
        class="telus-checkbox"
        color="secondary"
        (click)="onCheckboxClick($event, item)"
        [(ngModel)]="item.checked"
        [attr.aria-label]="item.text"
      ></ion-checkbox>

      <p>{{ item.text }}</p>
    </div>
  </div>
</div>

<div *ngIf="disabled">
  <ion-label class="dropdown-input"> {{ text }} </ion-label>
</div>
